<template>
  <HeaderContent />
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener('scroll', function () {
        var header_content = document.getElementById('header-content');
        var header_classes = header_content.classList;

        var page_content = document.getElementById('main-home');
        var page_classes = page_content.classList;

        /*
        if (document.documentElement.scrollTop >= 5) {
          if (header_classes.contains('shrink') === false) {
            header_classes.toggle('shrink');
            page_classes.toggle('page__padding--sm');
          }
        } else {
          if (header_classes.contains('shrink') === true) {
            header_classes.toggle('shrink');
            page_classes.toggle('page__padding--sm');
          }
        }
        */
      });
    });
  },
  methods: {},
};
</script>
